import React from 'react'

export const Timer = ({ time, textColor = 'has-text-white'  }) => {
  var sec_num = parseInt(time);
  var hours   = Math.floor(sec_num / 3600);
  var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
  var seconds = sec_num - (hours * 3600) - (minutes * 60);

  if (hours   < 10) {hours   = "0"+hours;}
  if (minutes < 10) {minutes = "0"+minutes;}
  if (seconds < 10) {seconds = "0"+seconds;}

  return (
    <div className={textColor}>
      {hours}:{minutes}:{seconds}
    </div>
  )
}